import { atom } from 'jotai';
import { MappingData } from 'api/fetchCommon';

export const mappingAtom = atom<MappingData | null>(null);
